<onyx-modal
  variant="right"
  [heading]="base()?.name ?? ''"
  [loading]="loading()"
  [(error)]="error"
  [close$]="close$"
  (errorChange)="base$.next()"
  (closeModal)="dialogRef.close()"
>
  <ng-container headingButtons>
    @if (base(); as base) {
      @if (authStore.hasPermission('bases.edit')) {
        <onyx-icon-button
          variant="transparent"
          color="gray"
          [size]="32"
          icon="edit-outlined"
          [circle]="true"
          onyxTooltip="labels.edit"
          (click)="edit()"
        ></onyx-icon-button>
      }

      <onyx-icon-button
        variant="transparent"
        color="gray"
        [size]="32"
        icon="telephone-outlined"
        [circle]="true"
        onyxTooltip="labels.call"
        (click)="ActionHelper.makeCall(base.phone)"
      ></onyx-icon-button>

      @if (options()?.length) {
        <onyx-icon-button
          variant="transparent"
          color="gray"
          [size]="32"
          icon="options-vertical-filled"
          [circle]="true"
          [onyxDropdownOptions]="options()"
          (onyxDropdownSelectedValueChange)="$event.value?.()"
          onyxTooltip="labels.options"
          (click)="$event.stopPropagation()"
        ></onyx-icon-button>
      }
    }
  </ng-container>

  @if (base(); as base) {
    <div class="container">
      <onyx-map [defer]="true"></onyx-map>

      <section>
        <onyx-information-heading>
          {{ 'labels.location' | translate }}
        </onyx-information-heading>

        <onyx-information-list>
          <onyx-information-row label="labels.address">
            <onyx-address
              [address]="base.address"
              format="short"
            ></onyx-address>

            <div class="copy">
              <onyx-icon-button
                variant="transparent"
                color="gray"
                [size]="24"
                icon="copy-filled"
                (click)="copyAddress(base.address)"
              ></onyx-icon-button>
            </div>
          </onyx-information-row>

          <onyx-information-row label="labels.coordinates">
            <onyx-address
              [address]="base.address"
              format="coordinates"
            ></onyx-address>

            <div class="copy">
              <onyx-icon-button
                variant="transparent"
                color="gray"
                [size]="24"
                icon="copy-filled"
                (click)="copyCoordinates(base.address)"
              ></onyx-icon-button>
            </div>
          </onyx-information-row>
        </onyx-information-list>
      </section>

      <section>
        <onyx-information-heading>
          {{ 'labels.openingHours' | translate }}
        </onyx-information-heading>

        <onyx-information-list>
          @let businessHours = base.businessHours;
          <onyx-information-row
            [label]="
              businessHours | businessHours: 'weekday' : 'long' : 'label'
            "
          >
            {{ businessHours | businessHours: 'weekday' : 'long' : 'value' }}
          </onyx-information-row>

          <onyx-information-row
            [label]="
              businessHours | businessHours: 'saturday' : 'long' : 'label'
            "
          >
            {{ businessHours | businessHours: 'saturday' : 'long' : 'value' }}
          </onyx-information-row>

          <onyx-information-row
            [label]="businessHours | businessHours: 'sunday' : 'long' : 'label'"
          >
            {{ businessHours | businessHours: 'sunday' : 'long' : 'value' }}
          </onyx-information-row>
        </onyx-information-list>
      </section>

      <section>
        <onyx-information-heading>
          {{ 'labels.contactData' | translate }}
        </onyx-information-heading>

        <onyx-information-row label="labels.phone">
          {{ base.phone | onyxPhone }}

          @if (base.phone) {
            <div class="copy">
              <onyx-icon-button
                variant="transparent"
                color="gray"
                [size]="24"
                icon="copy-filled"
                (click)="copyPhone(base.phone)"
              ></onyx-icon-button>
            </div>
          }
        </onyx-information-row>
      </section>

      <onyx-chips
        [chips]="sections()"
        variant="secondary"
        [single]="true"
        [gap]="8"
        [(activeValues)]="section"
      ></onyx-chips>

      <!-- N/A: Add search -->

      @switch (section()[0]) {
        @case (BaseSection.ASSIGNED_VEHICLES) {
          <onyx-table
            [data]="assignedVehicles()"
            [columns]="BASE_ASSIGNED_VEHICLES_COLUMNS"
            [tableShadow]="false"
            [rowSize]="48"
            [notFound]="BASE_ASSIGNED_VEHICLES_NOT_FOUND"
            [(pagination)]="pagination"
            (rowClick)="openVehicleModal($event.item)"
          ></onyx-table>
        }
        @case (BaseSection.ASSIGNED_DRIVERS) {
          <onyx-table
            [data]="assignedDrivers()"
            [columns]="BASE_ASSIGNED_DRIVERS_COLUMNS"
            [tableShadow]="false"
            [rowSize]="48"
            [notFound]="BASE_ASSIGNED_DRIVERS_NOT_FOUND"
            [(pagination)]="pagination"
            (rowClick)="openDriverModal($event.item)"
          ></onyx-table>
        }
      }
    </div>
  }
</onyx-modal>
